
import React from "react";
import MainLayout from "@/components/layout/MainLayout";
import Reports from "@/components/admin/Reports";

const AdminReports: React.FC = () => {
  return (
    <MainLayout>
      <Reports />
    </MainLayout>
  );
};

export default AdminReports;
